import React from 'react';

import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';

import { getRegions } from '@luxuryescapes/lib-regions';

const regionOptions = getRegions().map((region) => ({ code: region.code, name: region.name }));

export default function StandAloneMultiRegionsSelect({
  id,
  value,
  label,
  onChange,
}: {
  id: string;
  value: Array<string>;
  label: string;
  onChange: (value: Array<string>) => void;
}) {
  return (
    <FormControl fullWidth>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        multiple
        value={value}
        onChange={(e) => onChange(e.target.value as Array<string>)}
        renderValue={(selected) => selected.join(', ')}
        label={label}
      >
        {regionOptions.map((opt, i) => (
          <MenuItem key={`${i}_${opt.code}`} value={opt.code}>
            <Checkbox checked={value?.includes(opt.code)} />
            <ListItemText primary={opt.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
